<div class="settings-container">
  <header class="settings-header">
    <div class="section-tabs">
      @for (section of sections(); track section.header) {
        <div
          class="section-tab"
          [class.active]="selectedSection() === section.header"
          (click)="onSectionClick(section.header)">
          <app-display-icon [icon]="section.icon"></app-display-icon>
          <span>{{ section.header }}</span>
        </div>
      }
    </div>
  </header>

  <section
    class="two-col"
    [class.no-sidebar]="!showSidebar()"
    [class.sidebar-collapsed]="showSidebar() && isFeatureSidebarCollapsed()">
    @if (showSidebar()) {
      <aside
        class="sidebar"
        [class.collapsed]="isFeatureSidebarCollapsed()"
        (mouseenter)="onSidebarMouseEnter()"
        (mouseleave)="onSidebarMouseLeave()">
        @if (isFeatureSection()) {
          <button
            type="button"
            class="sidebar-toggle"
            [attr.aria-label]="isSidebarCollapsed() ? 'Expand feature menu' : 'Collapse feature menu'"
            (click)="onToggleSidebar()">
            <app-display-icon
              [colour]="iconColourEnum.primary"
              [icon]="isSidebarCollapsed() ? icons.chevronRight : icons.chevronLeft">
            </app-display-icon>
          </button>
        }
        <app-settings-layout-side-bar
          [collapsed]="isFeatureSidebarCollapsed()"
          [sectionFeatures]="selectedSectionFeatures()"
          [selectedStore]="selectedStore()"
          [selectedSection]="selectedSection()"
          [selectedSubSection]="selectedSubSection()"
          [selectedSetting]="selectedSetting()"
          (expandRequest)="onSidebarExpandRequest()">
        </app-settings-layout-side-bar>
      </aside>
    }

    <div class="view">
      @if (pageHeader(); as header) {
        <header class="settings-page-header"
                [ngClass]="{'account-settings-header' : header.title === 'User Profile' ||header.title === 'Email Notifications'}">
          <h2 class="settings-page-title">{{ header.title }}</h2>
          <p class="settings-page-subtitle">{{ header.subtitle }}</p>
        </header>
      }
      <div class="view-content">
        @if (showStoreSettingsNoPermission()) {
          <div class="settings-no-permission" role="status">
            <app-display-icon
              [border]="false"
              [colour]="iconColourEnum.red"
              [icon]="icons.lockClosedOutline">
            </app-display-icon>
            <h3 class="settings-no-permission-title">Insufficient Access</h3>
            <p class="settings-no-permission-text">
              You do not have permission to edit store settings for
              {{ selectedStore()?.name?.trim() || 'this store' }}.
              Switch to a store you administer, or ask an admin to grant Staff Access for this store.
            </p>
          </div>
        } @else {
          <ng-container *ngComponentOutlet="selectedSettingComponent()"></ng-container>
          @if (isFeatureContentLoading()) {
            <div class="settings-body-loading" role="status" aria-live="polite" aria-busy="true">
              <app-shared-loading-g [animation]="animation"></app-shared-loading-g>
              <p>Loading feature settings…</p>
            </div>
          }
        }
      </div>
    </div>
  </section>
</div>
